import { useContext } from "react";
import { ControlLayoutContext } from "@plansoft-configuration-renderer/layout";
const GRID_BREAKPOINTS = {
    xs: 12,
    sm: 6,
    md: 4,
    lg: 3,
    xl: 2,
};
const GRID_CONTAINER_SX = undefined;
/**
 * Get grid layout fallback
 * @returns
 */
export function useGridLayoutPropsFallback(options, settings) {
    const { defaultEnabled = false } = settings;
    let { gridEnabled = defaultEnabled, gridDirection = "row", gridSpacing = 1, gridColumnSpacing = gridSpacing, gridRowSpacing = gridSpacing, gridBreakpoints = GRID_BREAKPOINTS, gridContainerSx = GRID_CONTAINER_SX, } = options;
    // const emptyBreakpoints =
    //   Object.values(gridBreakpoints).filter(Boolean).length === 0;
    // if (emptyBreakpoints) {
    //   gridBreakpoints = "grow";
    // }
    return {
        gridEnabled,
        gridSpacing,
        gridColumnSpacing,
        gridRowSpacing,
        gridBreakpoints,
        gridDirection,
        gridContainerSx,
    };
}
/**
 * Get control props from layout for info values control
 * @returns
 */
export function useGridLayoutPropsFromContext(settings) {
    const contextProps = useContext(ControlLayoutContext);
    return useGridLayoutPropsFallback(contextProps, settings);
}
//# sourceMappingURL=useGridLayoutProps.js.map